import { fieldActionTypes } from "./field.types";

const initialState = {
  fields: [],
};

const fieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case fieldActionTypes.SET_FIELDS:
      return {
        ...state,
        fields: action.payload,
      };
    default:
      return state;
  }
};

export default fieldReducer;